import { ForgotPasswordForm } from '@/platform/auth/forgot-password-form';
import { AmbientBackground } from '@/platform/ui/ambient-background';

export default function ForgotPasswordPage() {
  return (
    <>
      <AmbientBackground />
      <div className="flex min-h-screen items-center justify-center p-4">
        <ForgotPasswordForm />
      </div>
    </>
  );
}
